import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import { isEqual } from "lodash";
import ReactTable from "react-table";
import { Popconfirm } from "antd";
import { Button, ButtonGroup } from "react-bootstrap";
import { deleteTrait, fetchTraitsList } from "../../../../api/menu/master-files/traits/actions";
import { fetchJobById, fetchJobs } from "../../../../api/menu/master-files/job-maintenance/actions";
import SearchSelect from "../../../common/SearchSelect";
import { findItemValueByIdFromArray } from "../../../../functions/find-item-by-id-from-array";
import filterCaseInsensitive from "../../../custom/forms/react-table-case-insensitive";
import TraitEditModal from "../job-maintenance/trait-edit-modal";
import { closeCustomModal, openCustomModal } from "../../../custom/modals";

class JobTraits extends Component {
    constructor(props) {
        super(props);

        this.state = {
            jobOptions: [],
            jobId: null
        };

        this.props.fetchJobs();
    }

    componentWillReceiveProps(nextProps) {
        if (!isEqual(nextProps.jobs, this.props.jobs)) {
            this.setState({
                jobOptions: nextProps.jobs.map(item => ({
                    value: item.id,
                    label: item.jobNumber
                }))
            });
        }
    }

    handleChangeJob = (option) => {
        const jobId = option.value;
        this.setState({
            jobId
        }, () => {
            this.props.fetchTraitJobs(jobId);
            this.props.fetchJobById(jobId);
        });
    };

    handleEditModal(trait = false) {
        const modalObj = {
            id: `trait-${trait || "new"}`,
            modalSettings: {
                size: "sm"
            },
            header: `${trait !== false ? "Update" : "Add"} Trait`,
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <TraitEditModal
                        trait={trait}
                        jobId={this.state.jobId}
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    }

    handleDelete(id) {
        this.props.deleteTrait(id, () => this.props.fetchTraitJobs(this.state.jobId));
    }

    render() {
        const {
            jobOptions,
            jobId
        } = this.state;

        const {
            jobTraits,
            loading,
            singleJob,
            jobLoading
        } = this.props;

        const jobCurrent = findItemValueByIdFromArray(
            jobOptions,
            "value",
            jobId
        ) || null;
        const classNameFlexCenter = "d-flex justify-content-center align-items-center";

        return (
            <div className="dashboard">
                <h3 className="mb-4">
                    Job Traits Maintenance
                </h3>

                <div>
                    <div className="form-group row">
                        <div className="col-4">
                            <label>Job</label>
                            <SearchSelect
                                className="custom-react-select"
                                isClearable={false}
                                isLoading={jobLoading}
                                options={jobOptions}
                                onChange={this.handleChangeJob}
                                value={jobCurrent}
                            />
                        </div>
                        <div className="col-4">
                            <label>Retailer</label>
                            <input
                                type="text"
                                className="form-control"
                                readOnly={true}
                                value={(singleJob && !loading) ? singleJob.retailer : ""}
                            />
                        </div>
                        <div className="col-4">
                            <label>Supplier</label>
                            <input
                                type="text"
                                className="form-control"
                                readOnly={true}
                                value={(singleJob && !loading) ? singleJob.supplier : ""}
                            />
                        </div>
                    </div>
                </div>
                <div>
                    <ReactTable
                        data={jobTraits}
                        headerClassName="table-header"
                        columns={[{
                            Header: "Trait Description",
                            accessor: "traitDescription",
                        }, {
                            Header: "Planogram",
                            accessor: "planogramCode",
                        }, {
                            Header: "Actions",
                            id: "actions",
                            className: classNameFlexCenter,
                            Cell: ({ original }) => (
                                <ButtonGroup>
                                    <Button size="sm" onClick={() => this.handleEditModal(original)}>
                                        <FontAwesomeIcon icon="pen" title="Update" />
                                    </Button>
                                    <Popconfirm
                                        title={"Delete trait?"}
                                        onConfirm={() => this.handleDelete(original.id)}
                                        placement="bottomRight"
                                        okText="Yes"
                                        cancelText="Cancel"
                                    >
                                        <Button variant="danger" size="sm">
                                            <FontAwesomeIcon icon="times" />
                                        </Button>
                                    </Popconfirm>
                                </ButtonGroup>
                            ),
                            filterable: false,
                            width: 100
                        }]}
                        showPagination={false}
                        pageSize={Math.max(jobTraits.length, 10)}
                        resizable
                        className="-striped -highlight"
                        loading={loading}
                        filterable
                        defaultFilterMethod={filterCaseInsensitive}
                        style={{
                            height: 500,
                        }}
                    />
                </div>
                <div className="d-flex justify-content-between mt-2">
                    <button
                        className="btn btn-primary"
                        onClick={() => this.handleEditModal(false)}
                    >
                        Add new
                    </button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    jobs: state.jobs.jobs,
    jobLoading: state.jobs.loading,
    jobTraits: state.traits.jobTraits,
    singleJob: state.jobs.singleJob,
    loading: state.traits.loading
});

const mapStateToDispatch = dispatch => ({
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),
    fetchJobs: bindActionCreators(fetchJobs, dispatch),
    fetchTraitJobs: bindActionCreators(fetchTraitsList, dispatch),
    fetchJobById: bindActionCreators(fetchJobById, dispatch),
    deleteTrait: bindActionCreators(deleteTrait, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(JobTraits);
